module.exports = __webpack_public_path__ + "img/weight-normal.e5cb6506.svg";